var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBenefit3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.97 2.87L16.005 0l-2.967 2.87-4.087-.578-.713 4.065-3.646 1.935L6.404 12 4.59 15.708l3.646 1.935.252 1.437-.002-.002.461 2.63h.002l4.087-.578L16.004 24l2.966-2.87 1.445.204 2.64.374h.002l.713-4.065 3.647-1.935L25.604 12l1.813-3.708-3.647-1.935-.713-4.065-4.086.578zM16.005 2l2.472 2.392 3.406-.482.594 3.388 3.039 1.612L24.004 12l1.51 3.09-3.038 1.612-.594 3.388-3.406-.482L16.004 22l-2.472-2.392-3.406.482-.594-3.388-3.039-1.612L8.003 12l-1.51-3.09 3.039-1.612.594-3.388 3.406.482L16.004 2zm2.6 3.297l2.53-.358.442 2.517.077.44.395.21 2.257 1.197-1.122 2.295-.197.402.197.402 1.122 2.295-2.258 1.198-.394.21-.077.44-.442 2.516-2.53-.358-.442-.062-.322.31-1.836 1.777-1.837-1.777-.32-.31-.443.062-2.53.358-.442-2.517-.077-.44-.395-.21-2.257-1.197 1.122-2.295.197-.402-.197-.402-1.122-2.295L9.96 8.105l.395-.21.077-.44.442-2.516 2.53.358.442.062.322-.31 1.836-1.777L17.84 5.05l.322.31.442-.062zM16.004 14l-2.5-2.5-2-.5.5 2 4 4 5-6 .5-2-2 .5-3.5 4.5zM1 27.5l6.369-9.007.761 4.34 4.206-.594-6.836 9.76-1-4-3.5-.5zM26.504 32l-6.837-9.761 4.206.595.761-4.342 6.37 9.008-3.5.5-1 4z",
    fill: "#fff",
    fillOpacity: 0.4
  })));
}

export default SvgBenefit3;